import Curriculum from "../assets/CV/TiozzoMatteo.pdf";



export const CV = () => {
    return (
        <button id="curriculum" onClick={() => window.open(Curriculum)}>See my curriculum</button>

    );
  };
  
